import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './styles.css'

const Form = ({ className, children, ...restProps }) => (
  <form {...restProps} className={classnames(styles.root, className)}>
    {children}
  </form>
)

Form.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}

Form.defaultProps = {
  className: '',
}

export const FormFieldset = ({ className, children, ...restProps }) => (
  <fieldset {...restProps} className={classnames(styles.fieldset, className)}>
    {children}
  </fieldset>
)

FormFieldset.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}

FormFieldset.defaultProps = {
  className: '',
}

export const FormChoiceGroup = ({
  className,
  label,
  children,
  ...restProps
}) => (
  <div {...restProps} className={classnames(styles.choiceGroup, className)}>
    {label && <span className={styles.label}>{label}</span>}

    <div className={styles.choices}>{children}</div>
  </div>
)

FormChoiceGroup.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
}

FormChoiceGroup.defaultProps = {
  className: '',
  label: '',
}

export const FormError = ({ meta }) => (
  <div>
    {meta.touched &&
      meta.error && <div className={styles.error}>{meta.error}</div>}
  </div>
)

FormError.propTypes = {
  meta: PropTypes.object.isRequired,
}

export default Form



// WEBPACK FOOTER //
// ../source/layouts/Form/index.js